import { render, staticRenderFns } from "./ResourceAvatarNew.vue?vue&type=template&id=a06d4e6c&scoped=true"
import script from "./ResourceAvatarNew.vue?vue&type=script&lang=ts"
export * from "./ResourceAvatarNew.vue?vue&type=script&lang=ts"
import style0 from "./ResourceAvatarNew.vue?vue&type=style&index=0&id=a06d4e6c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06d4e6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a06d4e6c')) {
      api.createRecord('a06d4e6c', component.options)
    } else {
      api.reload('a06d4e6c', component.options)
    }
    module.hot.accept("./ResourceAvatarNew.vue?vue&type=template&id=a06d4e6c&scoped=true", function () {
      api.rerender('a06d4e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/ResourceAvatarNew.vue"
export default component.exports